var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSiren(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_124044532986469716899415256844209658952",
    x1: "50%",
    x2: "50%",
    y1: "32.846%",
    y2: "90.794%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00FFA9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(3.524 4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#hinava_random_uuid_124044532986469716899415256844209658952)",
    d: "M10.267 0c.823 0 1.49.63 1.49 1.406v21.188c0 .776-.667 1.406-1.49 1.406-.824 0-1.491-.63-1.491-1.406V1.406C8.776.63 9.443 0 10.266 0zM7.285 3.553v16.894c-.92-1.291-2.481-2.119-4.228-2.119H.477V5.672h2.58c1.747 0 3.308-.828 4.228-2.12zm12.817 11.314l.029.03 2.308 2.461c.23.245.23.627 0 .872l-.187.2c-.24.256-.644.27-.901.028l-.03-.029-2.307-2.462c-.23-.245-.23-.626 0-.872l.186-.199c.241-.257.645-.27.902-.029zM13.249 7.86l3.727 1.172v5.936L13.25 16.14V7.86zm10.627 3.203c.332 0 .6.268.6.6v.4c0 .331-.268.6-.6.6h-3.3c-.331 0-.6-.269-.6-.6v-.4c0-.332.269-.6.6-.6h3.3zm-1.653-5.796l.029.03.187.198c.23.246.23.627 0 .872L20.13 8.83c-.241.257-.645.27-.901.03l-.03-.03-.186-.199c-.23-.245-.23-.627 0-.872l2.308-2.462c.24-.257.644-.27.9-.029z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiren);
export default __webpack_public_path__ + "static/media/siren.99f965b45ca0f93025c25d5354478034.svg";
export { ForwardRef as ReactComponent };